/** 单首音频上传上限（与 backend/config.tencent.js UPLOAD_LIMITS.audio 保持一致） */
export const AUDIO_UPLOAD_MAX_MB = 200;
export const AUDIO_UPLOAD_MAX_BYTES = AUDIO_UPLOAD_MAX_MB * 1024 * 1024;
export const AUDIO_UPLOAD_MAX_LABEL = `${AUDIO_UPLOAD_MAX_MB}MB`;

/** Nginx client_max_body_size：略高于业务上限，留给 multipart 边界开销 */
export const NGINX_AUDIO_BODY_SIZE = `${AUDIO_UPLOAD_MAX_MB + 1}m`;

export const AUDIO_FILE_ACCEPT =
  '.mp3,.wav,.flac,.aac,.m4a,audio/mp3,audio/mpeg,audio/wav,audio/flac,audio/aac,audio/mp4';
